<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> Used Device History
      </h1>
    </div>
    <section style="margin: 0 0 0 0;">
      <div class="content-info licenseUsedDetail">
        <p-table class="deviceTable pageAllOptions" #dtDocument [columns]="docTable_cols" [value]="docList" dataKey="DocNo" [paginator]="true" [rows]="10" [scrollable]="true">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
                <th *ngIf="i == 0" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                  {{col.header}}
                </th>
                <th *ngIf="i != 0" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="i != 9"></p-sortIcon>
                </th>
              </ng-template>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
            <tr [pSelectableRow]="rowData">
              <td style="width:50px" class="col-nowrap">
                <span>{{i+1}}</span>
              </td>
              <td style="width:150px" class="col-nowrap">
                <span>{{rowData.Company}}</span>
              </td>
              <td style="width:150px" class="col-nowrap">
                <span>{{rowData.MonthYear}}</span>
              </td>
              <td style="width:150px" class="col-nowrap">
                <span>{{rowData.DeviceUsage}}</span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="docTable_cols.length">
                <div translate class="ui-emptymessage">No Data found</div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </section>
  </div>
</div>
